import PropTypes from "prop-types";

/* Helper: Safe JSON parser */
const getNameFromJson = (jsonString) => {
    try {
        if (!jsonString) return "";
        const obj = JSON.parse(jsonString);
        return obj?.name || "";
    } catch (e) {
        return "";
    }
};

export default function BlogCard({ blog }) {

   let imageUrl = "/o/admin-theme/images/placeholder.png";

   if (blog.image) {
       if (blog.image.startsWith("http")) {
           imageUrl = blog.image;
       } else {
           imageUrl = window.location.origin + blog.image;
       }
   }

    const formattedDate = blog.blogDisplayDate
        ? new Date(blog.blogDisplayDate).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
        })
        : "";

    /*  Extract values */
    const categoryName = getNameFromJson(blog.categoriesType);
    const labelName = getNameFromJson(blog.blogCategoryLabels);

    return (
        <div className="story-slide">

            {/*  Badge (Featured) */}
            {labelName && (
                <div className="blog-badge">
                    {labelName}
                </div>
            )}
            
            <img
                src={imageUrl}
                alt={blog.title || "Blog image"}
                className="story-image-img"
            />

            <div className="blog-meta-row">

                {/*  Category + Read Time */}
                <div className="blog-readtime">
                    {categoryName && <span className="blog-category">{categoryName}</span>}
                    {categoryName && blog.readTime && ", "}
                    {blog.readTime || ""}
                </div>

                <div className="blog-date">
                    {formattedDate}
                </div>

            </div>


            <div className="title-desc">
            <a
             className="blog-title large-body font-w-400"
               href={blog.readMoreLink || "#"}
            >
                {blog.title}
            </a>


                <p className="blog-description small-body">
                    {blog.shortDescription || ""}
                </p>
            </div>
        </div>
    );
}

BlogCard.propTypes = {
    blog: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        shortDescription: PropTypes.string,
        readTime: PropTypes.string,
        blogDisplayDate: PropTypes.string,
        image: PropTypes.string,
        url: PropTypes.string,
        categoriesType: PropTypes.string,
        blogCategoryLabels: PropTypes.string,

    }).isRequired,
};